module.exports = __webpack_public_path__ + "img/pink.8c7801de.jpg";